import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tab, Nav } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import { Scrollbars } from 'react-custom-scrollbars';

import CompanyInfo from './tabContent/companyInfo';
import PrimaryContact from './tabContent/primaryContact';
import ContactDetails from './tabContent/contactDetails';
import ClientEvents from './tabContent/clientEvents';
//import RateCard from './tabContent/rateCard';
import DepartmentRateCard from './tabContent/departmentRateCard';
//import Events from './tabContent/events';
import DynamicFieldsDetails from '../commons/dynamicFieldsDetails';
import Documents from '../commons/documentTab';
import Toast from '../commons/helpers/toast';
import getCroppedImg from '../commons/image-cropper/cropImage';
import ModalWindow from '../commons/helpers/modalWindow';
import { userGroupUrlCheck, getUserTimeZone } from '../../utils/userGroupUrlCheck';

import { LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_CLIENTS, ROUTE_CLIENTS, DYNAMIC_PAGE_ICONS, DEFAULT_TIME_ZONE, CLIENT_EMAILS_MUTED, AFFILIATE_ALL_CLIENTS_EMAILS_MUTED } from '../../configs/staticConfigs'; // TAB7
import { MSG_DELETED, MSG_MAIL_RESEND, MSG_MAIL_RESEND_ERROR, MSG_LOGO_FORMAT, MSG_REQUIRED, MSG_CLIENT_INFO_SAVE, MSG_CLIENT_INFO_UPDATE, MSG_CLIENT_CNCT_SAVE, MSG_CLIENT_CNCT_SAVE_NO_EMAIL, MSG_CLIENT_CNCT_UPDATE, MSG_FILE_SIZE_ERROR, MSG_ERROR, MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS, MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR, MSG_TIMEZONE_DATA_ERROR, MSG_DATA_SAVE_ERROR, MSG_SERVER_DATA_FETCH_ERROR, MSG_CLIENT_DEACTIVATED, MSG_CLIENT_ACTIVATED, MSG_STATUS_UPDATED, MSG_CONFIRM_DATA_CHANGE_CLIENT,  MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED, MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED } from '../../configs/msgConfigs';
import { LBL_DELETED_CONFIRM, LBL_APP_NAME, LBL_ALL_EVENTS, LBL_COMPANY_PROFILE, LBL_RATE_CARD, LBL_ADD_CLIENT, LBL_EDIT_CLIENT, LBL_BASIC_INFO, LBL_PRIMARY_CONTACT, LBL_CONTACT_DETAILS, LBL_DOCUMENTS, LBL_ACTIVATE, LBL_DEACTIVATE, LBL_CLIENT, LBL_CONFIRM_DATA_CHANGE } from '../../configs/labelConfigs';
import { validationMsgClientAdd, validationMsgClientDetails } from '../../configs/validationConfigs';
import * as gLoc from '../../configs/googleConfigs';

//import {sectorAllListAction} from '../../actions/settings/superadmin/sectorActions';
//import {subSectorAllListAction} from '../../actions/settings/superadmin/subSectorActions';
import { clientGetCrewChiefBonusAction, clientProfileRateCardListAction, getCompanyBasicInfo, clientFullList, clientCategoryList, clientEditAction, clientCompanyInfoAddAction, clientPrmryCntAddAction, clientCompanyInfoUpdateAction, clientPrmryCntUpdateAction, clientActiveDeactiveAction, clientContactListAction, clientProfileDeactiveTabAction } from '../../actions/clientActions';
import { validateClientAddAction, validateClientDetailsAction } from '../../actions/validateActions';
import { clearAction, masterLocationListAction, primaryUsersListAction, resendEmailAction, timeZonesListAction, fromExpiryCertificates } from '../../actions/commonActions';
import { dynamicFieldsListAction, dynamicFieldsDataSaveAction } from '../../actions/settings/dynamicFieldsActions';

import * as types from '../../actions';
import { aflt_departmentsListAction } from '../../actions/settings/affiliates/aflt_departmentActions';

import { formValid, validateEmail, imageExtension, fileSize } from '../../utils/validation';
import { titleCase } from '../../utils/changeCase';
import { setStorage } from '../../utils/browserStorage';

let width = String(Number(window.innerWidth * .80));

class ClientProfileComponent extends Component {

    constructor(props) {
        super(props)

        let clientId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let timeZone = getUserTimeZone(this.props.location);
        let userGroup = '';
        let grpProfileId = '';
        let isClientLogin = false;
        let isSuperAdmin = false;
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            grpProfileId = userGroupData.profile_id;
        }

        if (userGroup === LOGIN_SUPER_ADMIN_GROUP) {
            isSuperAdmin = true;
        }

        if (userGroup === LOGIN_CLIENT_GROUP) {
            clientId = grpProfileId;
            isClientLogin = true;
        } else {
            clientId = this.props.clientId ? this.props.clientId : (this.props.match && this.props.match.params && this.props.match.params.id) ? this.props.match.params.id : 0;
        }

        this.state = {
            isClientLogin: isClientLogin,
            categorySaveSuccess: false,
            clientCategoryValidationMsg: '',
            onSave: false,
            clientCategoryBasicData: [],
            clientFullListData: [],
            formErrors: {
                companyName:'',
                companyEmail: '',
                companyContactNum: '',
                location: '',
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
                locationBilling: '',
                streetOneBilling: '',
                streetTwoBilling: '',
                cityBilling: '',
                stateBilling: '',
                countryBilling: '',
                postcodeBilling: '',
                firstName: '',
                lastName: '',
                contactNumber: '',
                emailAddress: '',
                timeZone: '',
                category: '',
                departments: '',
            },
            clientData: {
                companyInfo: {
                    companyName: null,
                    companyEmail: '',
                    companyContactNum: '',
                    websiteUrl: '',
                    companyRegNum: '',
                    vatNum: '',

                    locationId: null,
                    location: '',
                    googleLocation: null,
                    venue: '',
                    streetOne: '',
                    streetTwo: '',
                    city: null,
                    state: null,
                    country: null,
                    postcode: null,

                    locationIdBilling: null,
                    locationBilling: '',
                    googleLocationBilling: null,
                    venueBilling: '',
                    streetOneBilling: '',
                    streetTwoBilling: '',
                    cityBilling: null,
                    stateBilling: null,
                    countryBilling: null,
                    postcodeBilling: null,
                    
                    additionalText: '',
                    logo: '',
                    signature: '',
                    noLocationFound: false,
                    timeZone: timeZone.id,
                    category: null,
                    departments: [],
                    samePhysicalAddress: false,
                },
                primaryContact: {
                    firstName: null,
                    lastName: null,
                    contactNumber: null,
                    emailAddress: null,
                    position: '',
                    emailVerify: true,
                    prmyCnctAssUserId: '',
                    prmyCnctUserId: '',
                    chkSendVerifyEmail: false,
                    muteMails: false,
                    mutePushs: false,
                },
                activeTab: 'company-info-tab',
            },
            clientId: clientId,
            imgUrl: null,
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            formClick: false,
            isPrmCnctList: false,
            totalEvent: '',
            totalShift: '',
            isPrimaryContactSuccess: false,
            logoLabel: '', // MSG_LOGO_FORMAT
            signatureLabel: '', // MSG_LOGO_FORMAT
            isLogoValid: true,
            isSignatureValid: true,
            userType: LOGIN_CLIENT_GROUP,
            listDynData: { groupId: 0, reqFrom: 0 },
            dynFieldsAllItems: [],
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },
            activePageId: 0,
            dynamicFieldsSavedData: [],
            locGoogleCodes: {
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
            },
            timeZonesList: [],
            defaultTimeZoneId: timeZone.id,
            deptMultiSelList: [],
            departmentsList: [],
            is_active: '',
            clientProfileTabActiveShown: '',
            validationMsgArr: [],
            primaryContactEmailAddress: '',
            userGroup: userGroup,
            logoImgUrl: '',
            signImgUrl: '',
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea: {},
            croppedAreaPixels: {},
            rotation: 0,
            imgObj: null,
            addNewButtonClicked: 0,
            reloadContactList: 0,
            reloadRateCard: 0,
            clientActivatedSuccess: 0,
            clientDeactivatedSuccess: 0,
            activeDeactiveText: '',
            filteredClient: false,
            isSuperAdmin: isSuperAdmin,
            editAPIPrimaryContactsClientId: 0,
            editClientDetailsCalled: false,
            clientDepartmentsList: [],
            refTab: '',
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData = this.saveFormData.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.setToasterState = this.setToasterState.bind(this);
        this.changePage = this.changePage.bind(this);

        this.modalConfirm = React.createRef();
        this.logoModalCropper = React.createRef();
        this.signModalCropper = React.createRef();
    }

    callCertificateListAction = () => {
        this.props.callCertificateListAction();
    }

    resetStateOnClientAdd = (clientId, addNewButtonClicked) => {
        let timeZonesList = this.state.timeZonesList;
        let userGroup = this.state.userGroup;
        let reloadContactList = this.state.reloadContactList;
        let reloadRateCard = this.state.reloadRateCard;
        let timeZone = getUserTimeZone(this.props.location);

        let allDept = [];
        let deptId = 0;
        if (this.state.departmentsList.length > 0) {
            let tmpObj = {};
            let len = this.state.departmentsList.length;
            this.state.departmentsList.forEach((item, index) => {
                if (len === 1) {
                    tmpObj = { value: item.id, label: titleCase(item.name), inputVal: item.id };
                    deptId = item.id;
                }
                else {
                    tmpObj = { value: item.id, label: titleCase(item.name) };
                }
                allDept.push(tmpObj);
            })
        }
        else {
            this.props.aflt_departmentsListAction();
            // this.props.aflt_departmentsListAction({associated:'1'});
        }

        this.loadMultiSelDeptValues();

        this.setState({
            formErrors: {
                companyName: '',
                companyEmail: '',
                companyContactNum: '',
                location: '',
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
                locationBilling: '',
                streetOneBilling: '',
                streetTwoBilling: '',
                cityBilling: '',
                stateBilling: '',
                countryBilling: '',
                postcodeBilling: '',
                firstName: '',
                lastName: '',
                contactNumber: '',
                emailAddress: '',
                timeZone: '',
                category: '',
                departments: deptId > 0 ? '' : '',
            },
            clientData: {
                companyInfo: {
                    companyName: null,
                    companyEmail: '',
                    companyContactNum: '',
                    websiteUrl: '',
                    companyRegNum: '',
                    vatNum: '',
                    locationId: null,
                    location: '',
                    googleLocation: null,
                    venue: '',
                    streetOne: '',
                    streetTwo: '',
                    city: null,
                    state: null,
                    country: null,
                    postcode: null,
                    locationIdBilling: null,
                    locationBilling: '',
                    googleLocationBilling: null,
                    venueBilling: '',
                    streetOneBilling: '',
                    streetTwoBilling: '',
                    cityBilling: null,
                    stateBilling: null,
                    countryBilling: null,
                    postcodeBilling: null,
                    additionalText: '',
                    logo: '',
                    signature: '',
                    noLocationFound: false,
                    timeZone: this.state.defaultTimeZoneId,
                    category: null,
                    departments: deptId > 0 ? [deptId] : [],
                },
                primaryContact: {
                    firstName: null,
                    lastName: null,
                    contactNumber: null,
                    emailAddress: null,
                    position: '',
                    emailVerify: true,
                    prmyCnctAssUserId: '',
                    prmyCnctUserId: '',
                    chkSendVerifyEmail: false,
                },
                activeTab: 'company-info-tab',
            },
            clientId: clientId,
            imgUrl: null,
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            formClick: false,
            isPrmCnctList: false,
            totalEvent: '',
            totalShift: '',
            isPrimaryContactSuccess: false,
            logoLabel: '', // MSG_LOGO_FORMAT
            signatureLabel: '', // MSG_LOGO_FORMAT
            isLogoValid: true,
            isSignatureValid: true,
            userType: LOGIN_CLIENT_GROUP,
            listDynData: { groupId: 0, reqFrom: 0 },
            dynFieldsAllItems: [],
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },
            activePageId: 0,
            dynamicFieldsSavedData: [],
            locGoogleCodes: {
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
            },
            timeZonesList: timeZonesList,
            defaultTimeZoneId: this.state.defaultTimeZoneId ? this.state.defaultTimeZoneId : timeZone.id,
            is_active: '',
            clientProfileTabActiveShown: '',
            validationMsgArr: [],
            primaryContactEmailAddress: '',
            userGroup: userGroup,
            logoImgUrl: '',
            signImgUrl: '',
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea: {},
            croppedAreaPixels: {},
            rotation: 0,
            imgObj: null,
            addNewButtonClicked: addNewButtonClicked,
            reloadContactList: reloadContactList,
            reloadRateCard: reloadRateCard,
            clientActivatedSuccess: 0,
            clientDeactivatedSuccess: 0,
            activeDeactiveText: '',
            refTab: '',
            clientEventsTabClicked: 0
        });
    }

    onHideFilterBy = () => {
        // document.getElementById("filterByMenu").classList.remove('active');
        let filterByMenu = document.getElementById('filterByMenu');
        let filterTab = document.getElementById('filterTab');
        let quoteTab = document.getElementById('detailTab');
        filterTab.style.display = 'block';
        quoteTab.style.display = 'none';
        filterByMenu.style.width = '580px';
        filterByMenu.style.right = '-' + width + 'px';
        let clientData = this.state.clientData;
        clientData['activeTab'] = (this.props.calledFrom && this.props.calledFrom === 'certificates') ? 'documents-tab' : "company-info-tab";
        this.setState({ clientData, addNewButtonClicked: 0, filteredClient: false });
        this.props.setAddnewButtonClickedToZero();
        this.setState({ clientCategoryValidationMsg: '' })
    }

    callValidate = () => {
        if (this.state.clientId) this.props.validateClientDetailsAction(this.state.clientId);
    }

    loadMultiSelDeptValues() {
        let allDept = [];
        if (this.state.departmentsList.length > 0) {
            let tmpObj = {};
            let len = this.state.departmentsList.length;
            let deptId = 0;
            this.state.departmentsList.forEach((item, index) => {
                if (len === 1) {
                    tmpObj = { value: item.id, label: titleCase(item.name), inputVal: item.id };
                    deptId = item.id;
                }
                else {
                    tmpObj = { value: item.id, label: titleCase(item.name) };
                }
                allDept.push(tmpObj);
            })

            if (len === 1 && deptId > 0) {
                let actUserData = this.state.clientData;
                actUserData.companyInfo.departments = [deptId];
                let formErrors = this.state.formErrors;
                formErrors.departments = '';
                this.setState({ clientData: actUserData, deptMultiSelList: allDept, formErrors });
            }
            else {
                this.setState({ deptMultiSelList: allDept });
            }
        }
    }

    handleChangeMultiSel = (selectedDepts) => {
        let actUserDept = [];
        selectedDepts.forEach((item) => {
            actUserDept.push(item.value);
        });
        let actUserData = this.state.clientData;
        actUserData.companyInfo.departments = actUserDept;

        let formErrors = this.state.formErrors; // department  
        actUserData.companyInfo.departments = actUserDept;
        formErrors.departments = actUserDept.length === 0 ? MSG_REQUIRED : '';
        this.setState({ clientData: actUserData, formErrors, formClick: true });
    }

    changePage = (event, refPageId) => {
        if (this.state.activePageId !== refPageId) {
            let allPagesFieldsObj = [];
            let newActiveObj = {};
            this.state.dynFieldsAllItems.forEach((item, index) => {
                if (item.id === this.state.activePageId) allPagesFieldsObj.push(this.state.dynFieldsActiveItem);
                else allPagesFieldsObj.push(item);
                if (item.id === refPageId) {
                    newActiveObj = item;
                }
            });
            this.setState({ activePageId: refPageId, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems: allPagesFieldsObj, toastFlag: false, toastMessage: '', toastSuccess: true });
        }
    }

    onHandleChange = (e, tab) => {

        const { name } = e.target ? e.target : e.target.name;
        
        let value = e.target.type === "file" ? e.target.files[0] : e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        let trimmedValue = '';
        if (e.target.type === "text" || e.target.type === "tel" || e.target.type === "email") {
            trimmedValue = value.trim();
        }

        let formErrors = this.state.formErrors;
        let isSamePhysicalAddress = this.state.clientData.companyInfo.samePhysicalAddress;
        let logoValid = true;
        let logoError = ''; //MSG_LOGO_FORMAT;
        let signatureValid = true;
        let signatureError = ''; //MSG_LOGO_FORMAT; 

        switch (name) {
            case 'chkSendVerifyEmail':
                value = e.target.checked;
                break;
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if (!imageExtension(value.name)) {
                    logoError = MSG_LOGO_FORMAT;  
                    logoValid = false;
                }
                break;
            case 'signature':
                if (!fileSize(value.size)) {
                    signatureError = MSG_FILE_SIZE_ERROR;
                    signatureValid = false;
                }
                if (!imageExtension(value.name)) {
                    signatureError = MSG_LOGO_FORMAT; 
                    signatureValid = false;
                }
                break;
            case 'companyName':
                formErrors.companyName =
                    trimmedValue.length <= 0
                        ? MSG_REQUIRED : "";
                break;
            case 'companyEmail':
                formErrors.companyEmail =
                    trimmedValue.length > 0 && validateEmail(trimmedValue) === false
                        ? MSG_REQUIRED : "";
                break;
            case 'category':
                formErrors.category =
                    Number(value) === 0
                        ? MSG_REQUIRED : "";
                break;
            // case 'sector':      
            //     formErrors.sector =  
            //     value.length <=0 || Number(value)===0 ? 
            //     MSG_REQUIRED : "";
            //     break;  
            // case 'subSector':   
            //     formErrors.subSector = 
            //     value.length <=0 || Number(value)===0 ? 
            //     MSG_REQUIRED : ""
            //     break; 
            case 'firstName':
                formErrors.firstName =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break;
            case 'lastName':
                formErrors.lastName =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break;
            case 'contactNumber':
                formErrors.contactNumber =
                    trimmedValue.length <= 0
                        ? MSG_REQUIRED : "";
                break;
            case 'emailAddress':
                formErrors.emailAddress =
                    trimmedValue.length <= 0 || validateEmail(trimmedValue) === false
                        ? MSG_REQUIRED : "";
                break;
            // case 'streetOne':   
            //     formErrors.streetOne =  
            //     value.length <=0  ?
            //      MSG_REQUIRED : "";
            //     break;   
            // case 'streetTwo':   
            //     formErrors.streetTwo = 
            //     trimmedValue.length <=0  ? 
            //     MSG_REQUIRED : "";
            //     break;   
            case 'city':
                formErrors.city =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break;
            case 'state':
                formErrors.state =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break;
            case 'country':
                formErrors.country =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break; 
            case 'postcode':
                formErrors.postcode =
                    trimmedValue.length <= 0 ?
                        MSG_REQUIRED : "";
                break; 
                
            case 'samePhysicalAddress':
                value = e.target.checked; // Assign the checkbox value
                if (value) {
                    // If true, clear the errors for billing fields
                    formErrors.cityBilling = "";
                    formErrors.stateBilling = "";
                    formErrors.countryBilling = "";
                    formErrors.postcodeBilling = "";
                    formErrors.locationBilling = "";
                } 
                break;
            case 'cityBilling':
                formErrors.cityBilling =
                    (!isSamePhysicalAddress && trimmedValue.length <= 0) ?
                        MSG_REQUIRED : "";
                break;
            case 'stateBilling':
                formErrors.stateBilling =
                    (!isSamePhysicalAddress && trimmedValue.length <= 0) ?
                        MSG_REQUIRED : "";
                break;
            case 'countryBilling':
                formErrors.countryBilling =
                    (!isSamePhysicalAddress && trimmedValue.length <= 0) ?
                        MSG_REQUIRED : "";
                break;
            case 'postcodeBilling':
                formErrors.postcodeBilling =
                    (!isSamePhysicalAddress && trimmedValue.length <= 0) ?
                        MSG_REQUIRED : "";
                break;
            case 'timeZone':
                formErrors.timeZone = (value.length <= 0 || Number(value) === 0) ? MSG_REQUIRED : "";
                break;

            default:
                break;
        }

        let clientData = this.state.clientData;
        let companyInfo = this.state.clientData.companyInfo;
        let primaryContact = this.state.clientData.primaryContact;
        if (tab === 'company-info-tab') {
            if (name === 'category') {
                // this.setState({clientCategoryValidationMsg:''});
                companyInfo[name] = Number(value) === 0 ? null : value;
                // this.changeCategorySaveSuccess(true);
            }
            if (name === 'logo' && logoError === '') {
                companyInfo[name] = value;
            } if (name === 'signature' && signatureError === '') {
                companyInfo[name] = value;
            }
            else if (name !== 'logo' || name !== 'signature') {
                companyInfo[name] = value;
            }
            clientData.companyInfo = companyInfo;
        } else if (tab === 'company-primary-contact-tab') {
            primaryContact[name] = value;
        }

        if (e.target.type === "file" && name == 'logo') {
            let imgUrl = '';
            let imgObj = null;
            if (imageExtension(e.target.files[0].name) && logoError === '') {
                imgUrl = URL.createObjectURL(e.target.files[0]);
                imgObj = e.target.files[0]
                this.setState({ imgUrl: imgUrl, imgObj: imgObj, logoImgUrl: imgUrl }, () => {
                    document.getElementById('uploadLogo').value = '';
                    this.openLogoCropModal()
                });

            }
        } else if (e.target.type === "file" && name == 'signature') {
            let signatureUrl = '';
            let imgObj = null;
            if (imageExtension(e.target.files[0].name) && signatureError === '') {
                signatureUrl = URL.createObjectURL(e.target.files[0]);
                imgObj = e.target.files[0]
                this.setState({ signatureUrl: signatureUrl, imgObj: imgObj, signImgUrl: signatureUrl });
                document.getElementById('uploadSignature').value = '';
                this.openSignCropModal()
            }
        }
        // if(name === 'category' && formErrors.category === ""){
        //     this.props.validateClientAddAction(value);
        // }   

        this.setState({ formErrors, clientData, isLogoValid: logoValid, logoLabel: logoError, isSignatureValid: signatureValid, signatureLabel: signatureError });
    }

    onCropChange = crop => {
        this.setState({ crop })
    }

    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedArea, croppedAreaPixels: croppedAreaPixels })
    }

    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    openLogoCropModal = () => {
        this.logoModalCropper.current.handleOpenModal();
    }

    openSignCropModal = () => {
        this.signModalCropper.current.handleOpenModal();
    }
    cropImage(e, cropModule) {
        let { imgObj, croppedAreaPixels, rotation, imgUrl } = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            cropModule
        )
    }

    onSearchLocation = (query) => {
        if (query.length === 3) {
            this.props.masterLocationListAction(query);
        }
    }

    onClientSearch = (query) => {
        if (query.length >= 3) {
            this.props.clientFullList(query);
        }
        let formErrors = this.state.formErrors;
        let clientData = this.state.clientData;
        let companyInfo = this.state.clientData.companyInfo;
        formErrors.companyName = query.trim() ? '' : MSG_REQUIRED;
        companyInfo.companyName = query.trim() ? query : null;
        this.setState({ formErrors: formErrors, clientData });
    }
    onClientInputChange = (query) => {
        let formErrors = this.state.formErrors;
        let clientData = this.state.clientData;
        let companyInfo = this.state.clientData.companyInfo;
        formErrors.companyName = query.trim() ? '' : MSG_REQUIRED;
        companyInfo.companyName = query.trim() ? query : null;
        this.setState({ formErrors: formErrors, clientData });
    }

    onModalFormReset = () => {
        // this.setState({formClick:false});
    }

    onModalCancelClick = () => {
        let clientData = this.state.clientData;
        clientData.companyInfo.departments = this.state.clientDepartmentsList;
        // RESET DEPARTMENTS SELECTION ALSO 
        let formErrors = this.state.formErrors;
        if (this.state.clientDepartmentsList.length) {
            formErrors.departments = '';
        }
        let clientDepts = this.state.clientDepartmentsList;
        let allDept = [];
        if (this.state.departmentsList.length > 0) {
            this.state.departmentsList.forEach((item, index) => {
                if (clientDepts.includes(item.id)) allDept.push({ value: item.id, label: titleCase(item.name), inputVal: item.id });
                else allDept.push({ value: item.id, label: titleCase(item.name) });
            })
        }
        this.setState({ deptMultiSelList: allDept, clientData: clientData, formClick: false, formErrors }, () => {
            if (this.state.refTab && this.state.refTab.length) {
                this.onTabChange('', this.state.refTab);
                this.setState({ refTab: '' });
            }
        });
    }

    onTabChange = (e, tab) => {
        let eventsTabClicked = this.state.clientEventsTabClicked; 
        if(tab==='events-tab') {
            eventsTabClicked++; 
        }
        if (this.state.formClick === true) {
            this.modalConfirm.current.handleOpenModal();
        }
        else {
            if(eventsTabClicked===this.state.clientEventsTabClicked) {
                this.setState({ formClick: false, refTab: ''});
            }
            else {
                this.setState({ formClick: false, refTab: '', clientEventsTabClicked:eventsTabClicked });
            }
            this.makeTabActive(tab);
        }
    }

    makeTabActive = (tab) => {
        let clientData = this.state.clientData;
        let formErrors = this.state.formErrors;

        clientData['activeTab'] = tab;

        formErrors['firstName'] = clientData.primaryContact.firstName && clientData.primaryContact.firstName.length ? '' : MSG_REQUIRED;
        formErrors['lastName'] = clientData.primaryContact.lastName && clientData.primaryContact.lastName.length ? '' : MSG_REQUIRED;
        formErrors['contactNumber'] = clientData.primaryContact.contactNumber && clientData.primaryContact.contactNumber.length ? '' : MSG_REQUIRED;
        formErrors['emailAddress'] = clientData.primaryContact.emailAddress && clientData.primaryContact.emailAddress.length ? '' : MSG_REQUIRED;

        this.setState({ clientData, formErrors });
    }

    saveData = () => {
        this.saveFormData('', this.state.clientData.activeTab);
        this.setState({ formClick: false })
        this.modalConfirm.current.handleModelClose();
    }

    onPhoneInputChange = (value, data, event, formattedValue) => {
        let clientData = this.state.clientData;
        let companyInfo = this.state.clientData.companyInfo;
        companyInfo['companyContactNum'] = formattedValue.trim();
        this.setState({ clientData });
    }

    onContactInputChange = (value, data, event, formattedValue) => {
        let clientData = this.state.clientData;
        let formErrors = this.state.formErrors;
        let primaryContact = this.state.clientData.primaryContact
        primaryContact['contactNumber'] = formattedValue.trim();
        formErrors.contactNumber = value.trim() === data.dialCode ? MSG_REQUIRED : "";
        formErrors.contactNumber = formattedValue.trim().length < 5 ? MSG_REQUIRED : "";
        this.setState({ formErrors, clientData });
    }

    onSelectLocation = (selected, id) => {
        if (selected.length > 0) {
            const selectedLoc = selected[0];
            const { clientData } = this.state;
            const { companyInfo } = clientData;

            // Determine if it's billing or regular
            const isBilling = id !== "locationSearch";
            const prefix = isBilling ? "Billing" : "";

            const fields = {
                [`locationId${prefix}`]: selectedLoc.id || "",
                [`location${prefix}`]: selectedLoc.location || "",
                [`googleLocation${prefix}`]: selectedLoc.lat_long || "",
                [`venue${prefix}`]: selectedLoc.venue || "",
                [`streetOne${prefix}`]: selectedLoc.street1 || "",
                [`streetTwo${prefix}`]: selectedLoc.street2 || "",
                [`city${prefix}`]: selectedLoc.city || "",
                [`state${prefix}`]: selectedLoc.state || "",
                [`country${prefix}`]: selectedLoc.country || "",
                [`postcode${prefix}`]: selectedLoc.postcode || "",
                noLocationFound: false,
            };

            // Update companyInfo with the fields
            Object.assign(companyInfo, fields);

            this.setState({ clientData });
            this.resetFormErrors();
        }
    };

    onSelectClientList = (selected) => {
        if (selected.length > 0) {
            let selectedClient = selected[0];
            this.setState({ filteredClient: true });
            this.props.getCompanyBasicInfo(selectedClient.client_id);
        }
    }
    onClearClient = () => {

        let formErrors = this.state.formErrors;
        let clientData = this.state.clientData;
        let companyInfo = this.state.clientData.companyInfo;

        // formErrors.companyName = MSG_REQUIRED;
        // formErrors.location = MSG_REQUIRED;
        formErrors.timeZone = '';
        let timeZone = getUserTimeZone(this.props.location);
        this.resetFormErrors();
        companyInfo["companyName"] = null;
        companyInfo['companyEmail'] = '';
        companyInfo['companyContactNum'] = '';
        companyInfo['websiteUrl'] = '';
        companyInfo['companyRegNum'] = '';
        companyInfo['vatNum'] = '';
        companyInfo['location'] = '';
        companyInfo['locationId'] = '';
        companyInfo['googleLocation'] = '';
        companyInfo['venue'] = '';
        companyInfo['streetOne'] = '';
        companyInfo['streetTwo'] = '';
        companyInfo['city'] = null;
        companyInfo['state'] = null;
        companyInfo['country'] = null;
        companyInfo['postcode'] = null;
        companyInfo['locationBilling'] = '';
        companyInfo['locationIdBilling'] = '';
        companyInfo['googleLocationBilling'] = '';
        companyInfo['venueBilling'] = '';
        companyInfo['streetOneBilling'] = '';
        companyInfo['streetTwoBilling'] = '';
        companyInfo['cityBilling'] = null;
        companyInfo['stateBilling'] = null;
        companyInfo['countryBilling'] = null;
        companyInfo['postcodeBilling'] = null;
        companyInfo['additionalText'] = '';
        companyInfo['logo'] = '';

        companyInfo['signature'] = '';
        companyInfo['timeZone'] = timeZone.id;
        companyInfo['noLocationFound'] = false;
        companyInfo['noLocationFoundBilling'] = false;
        companyInfo['samePhysicalAddress'] = false;
        companyInfo['category'] = null;
        this.setState({ filteredClient: false, clientData, formErrors, clientFullListData: [] }, () => {

        });
    }

    onSelectPrmyUser = (e) => {
        let clientData = this.state.clientData;
        let primaryContact = this.state.clientData.primaryContact;
        primaryContact['prmyCnctAssUserId'] = e.target.value;
        const filteredUsers = this.props.prmryUsers.filter(item => item.associate_id === Number(e.target.value));
        primaryContact['firstName'] = filteredUsers[0].first_name;
        primaryContact['lastName'] = filteredUsers[0].last_name;
        primaryContact['contactNumber'] = filteredUsers[0].phone_number;
        primaryContact['emailAddress'] = filteredUsers[0].email;
        primaryContact['position'] = filteredUsers[0].position === null ? '' : filteredUsers[0].position;
        primaryContact['mutePushs'] = filteredUsers[0].mute_pushs;
        primaryContact['muteMails'] = filteredUsers[0].mute_mails;
        this.setState({ clientData });
    }

    resetFormErrors = () => {
        let formErrors = this.state.formErrors;
        formErrors.location = '';
        formErrors.companyName = '';
        formErrors.category = '';
        formErrors.streetOne = '';
        formErrors.streetTwo = '';
        formErrors.city = '';
        formErrors.state = '';
        formErrors.country = '';
        formErrors.postcode = '';
        formErrors.locationBilling = '';
        formErrors.streetOneBilling = '';
        formErrors.streetTwoBilling = '';
        formErrors.cityBilling = '';
        formErrors.stateBilling = '';
        formErrors.countryBilling = '';
        formErrors.postcodeBilling = '';
        formErrors.firstName = '';
        formErrors.lastName = '';
        formErrors.contactNumber = '';
        formErrors.emailAddress = '';
        formErrors.timeZone = this.state.clientData.companyInfo.timeZone ? '' : MSG_REQUIRED;
        this.setState({ formErrors });
    }

    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '', toastSuccess: false });
    }

    setToasterState(isEnabled, message, isSucces, isAutoHide = true, delay = 3000) {
        this.setState({ toastFlag: isEnabled, toastMessage: message, toastSuccess: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToast();
            }, delay);
        }
    }

    resendEmail = (userId) => {
        this.props.resendEmailAction(userId);
    }

    saveFormData = (e, tab) => {
        
        if (e) e.preventDefault();
        // WHILE ADDING A CLIENT CLEAR THE MASTER DATA ERROR ELEMENT FROM validationMsgArr  
        if (!this.state.clientId) this.setState({ validationMsgArr: [], formClick: true, onSave: true });
        else this.setState({ formClick: true, onSave: true });
        const clientId = this.state.clientId;
        const data = new FormData();
        const formErrors = this.state.formErrors;


        if (tab === 'company-info-tab') {
            const { companyInfo } = this.state.clientData;
            if (companyInfo.companyName === null || !companyInfo.companyName) {
                formErrors.companyName = MSG_REQUIRED;
            }
            if (companyInfo.category === null || !companyInfo.category) {
                formErrors.category = MSG_REQUIRED;
            }

            // if (companyInfo.location === null || !companyInfo.location) {
            //     formErrors.location = MSG_REQUIRED;
            // }
        
            if (companyInfo.city === null || !companyInfo.city) {
                formErrors.city = MSG_REQUIRED;
            }
            if (companyInfo.state === null || !companyInfo.state) {
                formErrors.state = MSG_REQUIRED;
            }
            if (companyInfo.country === null || !companyInfo.country) {
                formErrors.country = MSG_REQUIRED;
            }
            if (companyInfo.postcode === null || !companyInfo.postcode) {
                           
                formErrors.postcode = MSG_REQUIRED;
            }

            if (!companyInfo.samePhysicalAddress) {
                const requiredFields = ['cityBilling', 'stateBilling', 'countryBilling', 'postcodeBilling'];

                requiredFields.forEach((field) => {
                    if (!companyInfo[field]) {
                        formErrors[field] = MSG_REQUIRED;
                    }
                });
            }

            if (companyInfo.timeZone === null || !companyInfo.timeZone) {
                formErrors.timeZone = MSG_REQUIRED;
            }
            if (!this.state.isClientLogin && companyInfo.departments.length <= 0) {
                formErrors.departments = MSG_REQUIRED;
            }
            

            this.setState({ formErrors }, () => {
                if (formValid(this.state)) {
                    data.append('company_name', companyInfo.companyName);
                    data.append('web_site', companyInfo.websiteUrl);
                    data.append('phone_number', companyInfo.companyContactNum);
                    data.append('company_email', companyInfo.companyEmail);
                    data.append('company_no', companyInfo.companyRegNum);
                    data.append('vat_number', companyInfo.vatNum);
                    data.append('sector', (companyInfo.sector) ? companyInfo.sector : 0);
                    data.append('sub_sector', (companyInfo.subSector) ? companyInfo.subSector : 0);
                    data.append('note', companyInfo.additionalText);
                    data.append('logo', companyInfo.logo);
                    data.append('signature', companyInfo.signature);
                    data.append('category', companyInfo.category);
                    data.append('time_zone', companyInfo.timeZone);
                    data.append('filtered_client', this.state.filteredClient);
                    if (!this.state.isClientLogin) {
                        data.append('departments', JSON.stringify(companyInfo.departments));
                    }

                    if (companyInfo.locationId) {
                        data.append('location_id', companyInfo.locationId);
                    }
                    
                    const locationData = {
                        venue: companyInfo.venue,
                        street1: companyInfo.streetOne,
                        street2: companyInfo.streetTwo,
                        city: companyInfo.city,
                        state: companyInfo.state,
                        country: companyInfo.country,
                        postcode: companyInfo.postcode,
                        lat_long: companyInfo.lat_long,
                    };
                    
                    data.append('location_data', JSON.stringify(locationData));

                    if (companyInfo.samePhysicalAddress) {
                        data.append('billing_as_physical', companyInfo.samePhysicalAddress);
                    } else {
                        if (companyInfo.locationIdBilling) {
                            data.append('location_billing_id', companyInfo.locationIdBilling);
                        }
                    
                        const locationBillingData = {
                            venue: companyInfo.venueBilling,
                            street1: companyInfo.streetOneBilling,
                            street2: companyInfo.streetTwoBilling,
                            city: companyInfo.cityBilling,
                            state: companyInfo.stateBilling,
                            country: companyInfo.countryBilling,
                            postcode: companyInfo.postcodeBilling,
                            lat_long: companyInfo.googleLocationBilling,
                        };
                    
                        data.append('location_billing_data', JSON.stringify(locationBillingData));
                    }

                    if (clientId === undefined) {
                        this.props.clientCompanyInfoAddAction(data);
                    } else {
                        data.append('id', clientId);
                        this.props.clientCompanyInfoUpdateAction(data);
                    }
                } else {
                
                    if (companyInfo.companyName === null) {
                        formErrors.companyName = MSG_REQUIRED;
                    }
                    if (companyInfo.category === null) {
                        formErrors.category = MSG_REQUIRED;
                    }
                    // if(companyInfo.sector===0){
                    //     formErrors.sector = MSG_REQUIRED;
                    // }  
                    // if(companyInfo.subSector===0){
                    //     formErrors.subSector = MSG_REQUIRED;
                    // }                 
                    // if(companyInfo.streetOne===null){
                    //     formErrors.streetOne = MSG_REQUIRED;
                    // }   
                    if (companyInfo.city === null) {
                        formErrors.city = MSG_REQUIRED;
                    }
                    if (companyInfo.state === null) {
                        formErrors.state = MSG_REQUIRED;
                    }
                    if (companyInfo.country === null) {
                        formErrors.country = MSG_REQUIRED;
                    }
                    if (companyInfo.postcode === null) {
                        formErrors.postcode = MSG_REQUIRED;
                    }

                   if (!companyInfo.samePhysicalAddress) {
                    let billingFields = ['cityBilling', 'stateBilling', 'countryBilling', 'postcodeBilling'];

                    billingFields.forEach((field) => {
                        if (companyInfo[field] === null) {
                            formErrors[field] = MSG_REQUIRED;
                        }
                    });
                   }

                    if (companyInfo.timeZone === null) {
                        formErrors.timeZone = MSG_REQUIRED;
                    }
                    if (!this.state.isClientLogin && companyInfo.departments.length === 0) {
                        formErrors.departments = MSG_REQUIRED;
                    }

                    this.setState({ formErrors });
                }

            });

        } else if (tab === 'company-primary-contact-tab') {
            const { primaryContact } = this.state.clientData;
            if (formValid(this.state)) {
                if (this.state.isPrmCnctList) {
                    let primaryContactData = {
                        profileId: clientId,
                        userType: LOGIN_CLIENT_GROUP,
                        associate_id: primaryContact.prmyCnctAssUserId,
                        mute_mails: primaryContact.muteMails,
                        mute_pushs: primaryContact.mutePushs
                    }
                    this.props.clientPrmryCntUpdateAction(primaryContactData);
                } else {
                    let pcData = {
                        client_profile_id: clientId,
                        first_name: primaryContact.firstName,
                        last_name: primaryContact.lastName,
                        contact_number: primaryContact.contactNumber,
                        email: primaryContact.emailAddress,
                        send_email_verification: primaryContact.chkSendVerifyEmail,
                        position: primaryContact.position,
                        mute_mails: primaryContact.muteMails,
                        mute_pushs: primaryContact.mutePushs
                    }
                    this.props.clientPrmryCntAddAction(pcData);
                }

            } else {
                if (primaryContact.firstName === null) {
                    formErrors.firstName = MSG_REQUIRED;
                }
                if (primaryContact.lastName === null) {
                    formErrors.lastName = MSG_REQUIRED;
                }
                if (primaryContact.contactNumber === null) {
                    formErrors.contactNumber = MSG_REQUIRED;
                }
                if (primaryContact.emailAddress === null) {
                    formErrors.emailAddress = MSG_REQUIRED;
                }

                this.setState({ formErrors });
            }
        }
    }

    deactivateUser = () => {
        if (this.state.clientId) {
            let data = {
                active: false,
                profileId: this.state.clientId
            }
            this.setState({ activeDeactiveText: LBL_DEACTIVATE }, () => {
                this.props.clientActiveDeactiveAction(data);
            });
        }
    }

    activateUser = () => {
        if (this.state.clientId) {
            let data = {
                active: true,
                profileId: this.state.clientId
            }
            this.setState({ activeDeactiveText: LBL_ACTIVATE }, () => {
                this.props.clientActiveDeactiveAction(data);
            });
        }
    }


    setStateUpdate(client, activity, status, errorData, clientProfStatus, clientProfActivity, clientCategoryData, clientFullListActivity, clientFullData) {

        let arrTemp = [];
        let actString = '';
        if (clientProfActivity && clientProfActivity.length) {
            arrTemp = clientProfActivity.split('~~');
            actString = arrTemp[0];
        }

        if (actString === types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS) {
            this.setState({ clientCategoryBasicData: clientCategoryData });
        }
        if (clientFullListActivity && clientFullListActivity.length) {
            let arrClientTemp = clientFullListActivity.split('~~');
            let actClientString = arrClientTemp[0];
            if (actClientString === types.CLIENT_FULL_LIST_SUCCESS) {
                this.setState({ clientFullListData: clientFullData });
            }
        }

        let formErrors = this.state.formErrors;
        if (actString === types.RESEND_EMAIL_SUCCESS) {
            this.setToasterState(true, MSG_MAIL_RESEND, true, false);
        } else if (actString === types.RESEND_EMAIL_ERROR) {
            let sendErrMsg = MSG_MAIL_RESEND_ERROR; 
            if (errorData?.message) { 
                sendErrMsg = errorData.message===CLIENT_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED : 
                errorData.message===AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED : 
                MSG_MAIL_RESEND_ERROR;
            } 
            this.setToasterState(true,sendErrMsg,false); 
        } else if (actString === types.CLIENT_CMPNY_INFO_ADD_SUCCESS) {
            // this.props.validateClientDetailsAction(this.state.clientId);
            this.setToasterState(true, MSG_CLIENT_INFO_SAVE, true);
            this.setState({ clientId: client.id }, () => {
                this.props.clientEditAction(client.id);
            });
            // newClientId
            this.props.callClientListAction();
        } else if (actString === types.CLIENT_CMPNY_INFO_ADD_ERROR && this.state.onSave === true) {
            if (clientProfStatus === 400) {
                if (errorData.hasOwnProperty('company_name')) {
                    formErrors.companyName = errorData.company_name[0];
                } else {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
                }
                let onSave = false;
                this.setState({ formErrors, onSave });
            } else {
                this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
                // if(errorData.hasOwnProperty('message')){ 
                //     this.setToasterState(true,errorData.message,false);
                // }else{
                //     this.setToasterState(true,MSG_DATA_SAVE_ERROR,false);
                // }
            }
        } else if (actString === types.CLIENT_EDIT_SUCCESS) {
            // sector:client.sector, subSector:client.subSector,
            let timeZone = getUserTimeZone(this.props.location);
            let clientDepts = [];
            if (Array.isArray(client.departments)) clientDepts = client.departments;
            let allDept = [];
            if (this.state.departmentsList.length > 0) {
                this.state.departmentsList.forEach((item, index) => {
                    if (clientDepts.includes(item.id)) allDept.push({ value: item.id, label: titleCase(item.name), inputVal: item.id });
                    else allDept.push({ value: item.id, label: titleCase(item.name) });
                })
            }

            let activeTab = 'company-info-tab';
            if (this.props.calledFrom && this.props.calledFrom === 'certificates') activeTab = 'documents-tab';
           
            this.setState({
                deptMultiSelList: allDept,
                clientDepartmentsList: clientDepts,
                formClick: false,
                clientData: {
                    companyInfo: {
                        companyName: (client.companyName) ? client.companyName : '',
                        companyEmail: (client.companyEmail) ? client.companyEmail : '',
                        companyContactNum: (client.companyContactNum) ? client.companyContactNum : '',
                        websiteUrl: (client.websiteUrl) ? client.websiteUrl : '',
                        companyRegNum: (client.companyRegNum) ? client.companyRegNum : '',
                        vatNum: (client.vatNum) ? client.vatNum : '',

                        location: (client.location) ? client.location : '',
                        locationId: client.locationId,
                        googleLocation: (client.googleLocation) ? client.googleLocation : '',
                        venue: (client.venue) ? (client.venue) : '',
                        streetOne: (client.streetOne) ? client.streetOne : '',
                        streetTwo: (client.streetTwo) ? client.streetTwo : '',
                        city: (client.city) ? client.city : '',
                        state: (client.state) ? client.state : '',
                        country: (client.country) ? client.country : '',
                        postcode: (client.postcode) ? client.postcode : '',

                        samePhysicalAddress: client.locationId === client.locationIdBilling,
                        
                        ...(client.locationId !== client.locationIdBilling && {
                            locationBilling: client.locationBilling || '',
                            locationIdBilling: client.locationIdBilling,
                            googleLocationBilling: client.googleLocationBilling || '',
                            venueBilling: client.venueBilling || '',
                            streetOneBilling: client.streetOneBilling || '',
                            streetTwoBilling: client.streetTwoBilling || '',
                            cityBilling: client.cityBilling || '',
                            stateBilling: client.stateBilling || '',
                            countryBilling: client.countryBilling || '',
                            postcodeBilling: client.postcodeBilling || '',
                        }),
                        
                        additionalText: (client.additionalText) ? client.additionalText : '',
                        logo: '',
                        signature: '',
                        noLocationFound: false,
                        timeZone: (client.timeZone) ? client.timeZone.id : timeZone.id,
                        category: client.category ? client.category : '',
                        departments: clientDepts,
                    },
                    primaryContact: {
                        prmyCnctAssUserId: client.prmyCnctAssUserId,
                        prmyCnctUserId: client.prmyCnctUserId,
                        firstName: client.firstName,
                        lastName: client.lastName,
                        contactNumber: client.contactNumber,
                        emailAddress: client.emailAddress,
                        position: client.position,
                        emailVerify: client.emailVerify,
                        chkSendVerifyEmail: false,
                        mutePushs: client.mutePushs,
                        muteMails: client.muteMails
                    },
                    activeTab: activeTab
                },
                imgUrl: client.logo,
                signatureUrl: client.signature,
                isPrmCnctList: client.isPrmCnctList,
                totalEvent: client.totalEvent,
                totalShift: client.totalShift,
                clientId: client.id,
                dynamicFieldsSavedData: client.dynamic_fields,
                is_active: client.is_active,
                client_affiliate_status: client.client_affiliate_status,
                primaryContactEmailAddress: client.emailAddress,
                formErrors: {
                    companyName: '',
                    companyEmail: '',
                    companyContactNum: '',
                    location: '',
                    // location: parseInt(client.locationId, 10) ? '' : MSG_REQUIRED,
                    streetOne: '',
                    streetTwo: '',
                    city: '',
                    state: '',
                    country: '',
                    postcode: '',
                    locationBilling: '',
                    // locationBilling: parseInt(client.locationIdBilling, 10) ? '' : MSG_REQUIRED,
                    streetOneBilling: '',
                    streetTwoBilling: '',
                    cityBilling: '',
                    stateBilling: '',
                    countryBilling: '',
                    postcodeBilling: '',
                    firstName: '',
                    lastName: '',
                    contactNumber: '',
                    emailAddress: '',
                    timeZone: '',
                    category: '',
                    departments: '',
                }
            });

            if (client.isPrmCnctList) {
                // TO PREVENT REPEATED API CALLS 
                if (this.state.editAPIPrimaryContactsClientId !== client.id) {
                    let data = {
                        profileId: client.id,
                        userType: LOGIN_CLIENT_GROUP
                    }
                    this.props.primaryUsersListAction(data);
                    this.setState({ editAPIPrimaryContactsClientId: client.id });
                }
            }

            const { location } = this.props;
            let userGroupData = userGroupUrlCheck(location);
            let userGroup = '';
            if (userGroupData !== undefined) {
                userGroup = userGroupData.user_group;
            }

            let grpProfileId = userGroupData.profile_id;
            let listDynData = { groupId: LOGIN_CLIENT_GROUP, reqFrom: userGroup, profileId: grpProfileId };
            this.setState({ listDynData: listDynData }, () => {
                this.props.dynamicFieldsListAction(listDynData);
            });
            this.props.callClientListAction();
            // IF THIS PAGE IS CALLED FORM CERTIFICATES LISTING - MAKE DOCUMENTS TAB ACTIVE
            if (this.props.clientProfileTabActive !== this.state.clientProfileTabActiveShown) {
                if (this.props.clientProfileTabActive && this.props.clientProfileTabActive.length > 0 && this.state.clientProfileTabActiveShown === '') {
                    this.setState({ clientProfileTabActiveShown: this.props.clientProfileTabActive });
                    this.onTabChange('', this.props.clientProfileTabActive);
                }
                this.props.clientProfileDeactiveTabAction('');
            }

        } else if (actString === types.CLIENT_EDIT_ERROR) {
            let gotoURL = this.state.userGroup === LOGIN_SUPER_ADMIN_GROUP ? ROUTE_CLIENTS : ROUTE_AFFILIATE_CLIENTS;
            if (clientProfStatus === 404) {
                this.props.history.push(gotoURL)
            }
            else {
                this.setToasterState(true, MSG_SERVER_DATA_FETCH_ERROR, false);
            }
        } else if (actString === types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS) {
            this.setState({ clientDepartmentsList: this.state.clientData.companyInfo.departments, formClick: false });
            this.callValidate();
            let affiliateId = null;
            let userGroupData = userGroupUrlCheck(this.props.location);
            if (userGroupData !== undefined && userGroupData.user_group && userGroupData.user_group === LOGIN_CLIENT_GROUP) {
                let timeZoneId = this.state.clientData.companyInfo.timeZone;
                let tz = this.state.timeZonesList;
                let newTZ = tz.filter(item => Number(item.id) === Number(timeZoneId));
                userGroupData.time_zone = newTZ[0];
                setStorage('client', JSON.stringify(userGroupData));
            } else if (userGroupData !== undefined && userGroupData.user_group && userGroupData.user_group === LOGIN_AFFILIATE_GROUP) {
                affiliateId = userGroupData.profile_id;
                let tmpObj = { affiliateId: affiliateId, clientId: client.id }
                // this.props.clientProfileRateCardListAction(tmpObj);
                // this.props.clientGetCrewChiefBonusAction(client.id); 
            }
            this.props.callClientListAction();
            this.setToasterState(true, MSG_CLIENT_INFO_UPDATE, true);

            if (this.state.refTab && this.state.refTab.length) {
                this.onTabChange('', this.state.refTab);
                this.setState({ formClick: false, refTab: '' });
            }

        } else if (actString === types.CLIENT_CMPNY_INFO_UPDATE_ERROR) {
            if (clientProfStatus === 400) {
                if (errorData.hasOwnProperty('company_name')) {
                    formErrors.companyName = errorData.company_name[0];
                } else {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
                }
                this.setState(formErrors);
            } else {
                this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
                // if(errorData.hasOwnProperty('message')){ 
                //     this.setToasterState(true,errorData.message,false);
                // }else{
                //     this.setToasterState(true,JSON.stringify(errorData),false);
                // }
            }
        } else if (actString === types.CLIENT_PRMRY_CNCT_ADD_SUCCESS) {
            let emailAddress = this.state.clientData.primaryContact.emailAddress;
            let reloadContactList = Number(this.state.reloadContactList) + 1;
            this.setState({
                isPrimaryContactSuccess: true, primaryContactEmailAddress: emailAddress, reloadContactList: reloadContactList, formClick: false 
            });
            if (this.state.clientData.primaryContact.chkSendVerifyEmail) this.setToasterState(true, MSG_CLIENT_CNCT_SAVE, true, false);
            else this.setToasterState(true, MSG_CLIENT_CNCT_SAVE_NO_EMAIL, true, false);

            this.callValidate();
            this.props.callClientListAction();
        } else if (actString === types.CLIENT_PRMRY_CNCT_ADD_ERROR) {
            if (clientProfStatus === 400) {
                if (errorData.hasOwnProperty('email')) {
                    formErrors.emailAddress = errorData.email[0];
                } else {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
                }
                this.setState(formErrors);
            } else {
                this.setToasterState(true, MSG_DATA_SAVE_ERROR, false);
                // if(errorData.hasOwnProperty('message')){ 
                //     this.setToasterState(true,errorData.message,false);
                // }else{
                //     this.setToasterState(true,JSON.stringify(errorData),false);
                // }
            }
        } else if (actString === types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS) {
            let reloadContactList = Number(this.state.reloadContactList) + 1;
            this.setState({ reloadContactList: reloadContactList, formClick: false });
            this.setToasterState(true, MSG_CLIENT_CNCT_UPDATE, true);
            this.callValidate();
            this.props.callClientListAction();
        } else if (actString === types.CLIENT_PRMRY_CNCT_UPDATE_ERROR) {
            if (clientProfStatus === 400) {
                if (errorData.hasOwnProperty('email')) {
                    formErrors.emailAddress = errorData.email[0];
                } else {
                    this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
                }
                this.setState(formErrors);
            } else {
                this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
                // if(errorData.hasOwnProperty('message')){ 
                //     this.setToasterState(true,errorData.message,false);
                // }else{
                //     this.setToasterState(true,JSON.stringify(errorData),false);
                // }
            }
        } else if (actString === types.CLIENT_ACTIVE_DEACTIVE_SUCCESS) {
            let msgStr = '';
            if (this.props.activeStatus === LBL_DELETED_CONFIRM) {
                msgStr = LBL_CLIENT + " " + MSG_DELETED;
            } else {
                msgStr = this.state.activeDeactiveText === LBL_ACTIVATE ? (LBL_CLIENT + " " + this.state.clientData.companyInfo.companyName + " " + MSG_CLIENT_ACTIVATED) : this.state.activeDeactiveText === LBL_DEACTIVATE ? MSG_CLIENT_DEACTIVATED : MSG_STATUS_UPDATED;
            }

            if (this.state.activeDeactiveText === LBL_ACTIVATE) {
                let nextNum = Number(this.state.clientActivatedSuccess) + 1;
                this.setState({ clientActivatedSuccess: nextNum, clientId: 0 });
            }
            else {
                let nextNum = Number(this.state.clientDeactivatedSuccess) + 1;
                this.setState({ clientDeactivatedSuccess: nextNum, clientId: 0 });
            }

            this.setToasterState(true, msgStr, true);
            this.props.callClientListAction();
            this.onHideFilterBy();
            // this.resetStateOnClientAdd(this.props.clientId,addNewButtonClicked)
        } else if (actString === types.CLIENT_ACTIVE_DEACTIVE_ERROR) {
            this.setToasterState(true, MSG_DATA_SAVE_ERROR, false); // JSON.stringify(errorData)
        }
    }

    googleLocSelect = (address, id) => {
        let { formErrors } = this.state;
        let clientData = this.state.clientData;
        let locGoogleCodes = this.state.locGoogleCodes;

        geocodeByAddress(address)
            .then(results => {
                if (id === "googleLocation") {
                    clientData.companyInfo.streetOne = '';
                    clientData.companyInfo.streetTwo = '';
                    clientData.companyInfo.city = '';
                    clientData.companyInfo.state = '';
                    clientData.companyInfo.country = '';
                    clientData.companyInfo.postcode = '';
                    clientData.companyInfo.location = results[0].formatted_address;
                    let tmpArr = [];
                    tmpArr = address.split(',');
                    clientData.companyInfo.venue = tmpArr[0];

                    locGoogleCodes.streetOne = '';
                    locGoogleCodes.streetTwo = '';
                    locGoogleCodes.city = '';
                    locGoogleCodes.state = '';
                    locGoogleCodes.country = '';
                    locGoogleCodes.postcode = '';

                    let allAddress = results[0].address_components;
                    let addrTypes = [];
                    let foundVar = 0;
                    let tmpVal = '';
                    allAddress.forEach(element => {
                        addrTypes = element.types;
                        foundVar = 0;
                        addrTypes.forEach(item => {
                            tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '');
                            if (foundVar === 0 && tmpVal !== '') {
                                if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['streetOne'].trim() === '') clientData.companyInfo['streetOne'] = tmpVal;
                                    else clientData.companyInfo['streetOne'] += ', ' + tmpVal;

                                    if (locGoogleCodes['streetOne'].trim() === '') locGoogleCodes['streetOne'] = item;
                                    else locGoogleCodes['streetOne'] += ', ' + item;
                                }
                                else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['streetTwo'].trim() === '') clientData.companyInfo['streetTwo'] = tmpVal;
                                    else clientData.companyInfo['streetTwo'] += ', ' + tmpVal;
                                    if (locGoogleCodes['streetTwo'].trim() === '') locGoogleCodes['streetTwo'] = item;
                                    else locGoogleCodes['streetTwo'] += ', ' + item;
                                }
                                else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['city'].trim() === '') clientData.companyInfo['city'] = tmpVal;
                                    else clientData.companyInfo['city'] += ', ' + tmpVal;
                                    if (locGoogleCodes['city'].trim() === '') locGoogleCodes['city'] = item;
                                    else locGoogleCodes['city'] += ', ' + item;
                                }
                                else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['state'].trim() === '') clientData.companyInfo['state'] = tmpVal;
                                    else clientData.companyInfo['state'] += ', ' + tmpVal;
                                    if (locGoogleCodes['state'].trim() === '') locGoogleCodes['state'] = item;
                                    else locGoogleCodes['state'] += ', ' + item;
                                }
                                else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['country'].trim() === '') clientData.companyInfo['country'] = tmpVal;
                                    else clientData.companyInfo['country'] += ', ' + tmpVal;
                                    if (locGoogleCodes['country'].trim() === '') locGoogleCodes['country'] = item;
                                    else locGoogleCodes['country'] += ', ' + item;
                                }
                                else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['postcode'].trim() === '') clientData.companyInfo['postcode'] = tmpVal;
                                    else clientData.companyInfo['postcode'] += ', ' + tmpVal;
                                    if (locGoogleCodes['postcode'].trim() === '') locGoogleCodes['postcode'] = item;
                                    else locGoogleCodes['postcode'] += ', ' + item;
                                }
                            }
                        })
                    })

                    getLatLng(results[0]).then(latLng => {
                        clientData.companyInfo['googleLocation'] = latLng.lat + ',' + latLng.lng;
                    })
                } else {
                    clientData.companyInfo.streetOneBilling = '';
                    clientData.companyInfo.streetTwoBilling = '';
                    clientData.companyInfo.cityBilling = '';
                    clientData.companyInfo.stateBilling = '';
                    clientData.companyInfo.countryBilling = '';
                    clientData.companyInfo.postcodeBilling = '';
                    clientData.companyInfo.locationBilling = results[0].formatted_address;
                    let tmpArr = [];
                    tmpArr = address.split(',');
                    clientData.companyInfo.venueBilling = tmpArr[0];

                    let allAddress = results[0].address_components;
                    let addrTypes = [];
                    let foundVar = 0;
                    let tmpVal = '';
                    allAddress.forEach(element => {
                        addrTypes = element.types;
                        foundVar = 0;
                        addrTypes.forEach(item => {
                            tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '');
                            if (foundVar === 0 && tmpVal !== '') {
                                if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['streetOneBilling'].trim() === '') clientData.companyInfo['streetOneBilling'] = tmpVal;
                                    else clientData.companyInfo['streetOneBilling'] += ', ' + tmpVal;
                                }
                                else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['streetTwoBilling'].trim() === '') clientData.companyInfo['streetTwoBilling'] = tmpVal;
                                    else clientData.companyInfo['streetTwoBilling'] += ', ' + tmpVal;
                                }
                                else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['cityBilling'].trim() === '') clientData.companyInfo['cityBilling'] = tmpVal;
                                    else clientData.companyInfo['cityBilling'] += ', ' + tmpVal;
                                }
                                else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['stateBilling'].trim() === '') clientData.companyInfo['stateBilling'] = tmpVal;
                                    else clientData.companyInfo['stateBilling'] += ', ' + tmpVal;
                                }
                                else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['countryBilling'].trim() === '') clientData.companyInfo['countryBilling'] = tmpVal;
                                    else clientData.companyInfo['countryBilling'] += ', ' + tmpVal;
                                }
                                else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                                    foundVar = 1;
                                    if (clientData.companyInfo['postcodeBilling'].trim() === '') clientData.companyInfo['postcodeBilling'] = tmpVal;
                                    else clientData.companyInfo['postcodeBilling'] += ', ' + tmpVal;
                                }
                            }
                        })
                    })
                }
            }).then(() => {
                if (id === "googleLocation") {
                    formErrors['streetOne'] = '';
                    formErrors['city'] = '';
                    formErrors['state'] = '';
                    formErrors['country'] = '';
                    formErrors['postcode'] = '';
                    formErrors['location'] = '';
                } else {
                    formErrors['streetOneBilling'] = '';
                    formErrors['cityBilling'] = '';
                    formErrors['stateBilling'] = '';
                    formErrors['countryBilling'] = '';
                    formErrors['postcodeBilling'] = '';
                    formErrors['locationBilling'] = '';
                }
                this.setState({ clientData: clientData, locGoogleCodes: locGoogleCodes, formErrors });
            })
            .catch(error => console.error('Error', error));
    }

    onGetGoogleLoc = (e, id) => {
        const { name, checked } = e.target;
        const { clientData } = this.state;
        const isBilling = id === "noLocationFoundBilling";

        const fields = [
            "locationId",
            "venue",
            "googleLocation",
            "streetOne",
            "streetTwo",
            "city",
            "state",
            "country",
            "postcode",
        ];

        // Prefix fields with "Billing" if it's for billing
        fields.forEach((field) => {
            const key = isBilling ? `${field}Billing` : field;
            clientData.companyInfo[key] = "";
        });

        // Set "noLocationFound" field
        const noLocationKey = isBilling ? "noLocationFoundBilling" : "noLocationFound";
        clientData.companyInfo[noLocationKey] = checked;

        // Update the specific checkbox value
        clientData.companyInfo[name] = checked;

        this.setState({ clientData });
    };

    componentDidUpdate(prevProps) {
        const { clientBasicInfoActivity, clientBasicInfoData, clientCategoryData, client, status, activity, errorData, dynFieldsStatus, dynFieldsActivity, timezonesListStatus, timezonesListActivity, clientProfileTabActive, validateResponse, validateStatus, validateActivity, validateErrorData, clientId, addNewButtonClicked, clientProfStatus, clientProfActivity, clientFullListActivity, clientFullData, afltDepartmentsForCrew, crewProfileActivity } = this.props;

        if (addNewButtonClicked && Number(addNewButtonClicked) > Number(this.state.addNewButtonClicked)) {
            this.resetStateOnClientAdd(clientId, addNewButtonClicked);
            // this.props.validateClientAddAction(); // TO VALIDATE MANDATORY DATA ADDED BEFORE CREATING CLIENT
        }

        if (clientId && Number(clientId) > 0 && (this.state.clientId !== clientId || !this.state.editClientDetailsCalled)) {
            let reloadContactList = Number(this.state.reloadContactList) + 1;
            let reloadRateCard = Number(this.state.reloadRateCard) + 1;
            this.setState({ clientId: clientId, reloadContactList: reloadContactList, reloadRateCard: reloadRateCard, editClientDetailsCalled: true }, () => {
                const clientId = this.state.clientId;
                this.resetStateOnClientAdd(clientId, this.state.addNewButtonClicked);
                this.props.clientEditAction(clientId);
                this.props.validateClientDetailsAction(clientId); // TO VALIDATE MANDATORY DATA ADDED WHITE EDIT CLIENT DETAILS 
            })
        }

        if (validateActivity && (validateStatus !== prevProps.validateStatus || validateActivity !== prevProps.validateActivity)) {
            var arrTemp = validateActivity.split('~~');
            if (arrTemp[0] === types.VALIDATE_CLIENT_ADD_SUCCESS) {
                if (validateStatus === 200) {
                    this.setState({ clientCategoryValidationMsg: '' })
                } else {
                    this.setState({ clientCategoryValidationMsg: validationMsgClientAdd[validateResponse.mandatories] });
                }
            }
            else if (arrTemp[0] === types.VALIDATE_CLIENT_DETAILS_SUCCESS) {
                if (validateStatus === 200) {
                    this.setState({ validationMsgArr: [] });
                }
                else { // if(validateStatus!==200)
                    if (validateResponse.mandatories && Array.isArray(validateResponse.mandatories)) {
                        this.setState({ validationMsgArr: validateResponse.mandatories });
                    }
                    else {
                        // this.setState({validationMsgArr:['common_error']});
                        console.log('validateResponse not have mandatories array/object');
                        console.log(validateResponse);
                    }

                } // validateErrorData
            }
        }

        if (crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity) {
            let arrRespDept = crewProfileActivity.split('~~');
            let actStringDept = arrRespDept[0];

            if (actStringDept === types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) {
                if (this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if (this.props.afltDepartmentsForCrew.length === 0) {
                        this.setState({ departmentsList: [] }, () => {
                            this.loadMultiSelDeptValues();
                        });
                    }
                    else {
                        this.setState({ departmentsList: this.props.afltDepartmentsForCrew }, () => {
                            this.loadMultiSelDeptValues();
                        });
                    }
                }
            }
        }

        if ((activity && activity !== prevProps.activity) || (clientProfActivity && clientProfActivity !== prevProps.clientProfActivity) || (clientFullListActivity && clientFullListActivity !== prevProps.clientFullListActivity)) {

            this.setStateUpdate(client, activity, status, errorData, clientProfStatus, clientProfActivity, clientCategoryData, clientFullListActivity, clientFullData);
            this.props.clearAction();

        }

        if (clientBasicInfoActivity && clientBasicInfoActivity !== prevProps.clientBasicInfoActivity) {
            var arrResp = clientBasicInfoActivity.split('~~');
            var actString = arrResp[0];
            if (actString === types.CLIENT_COMPANY_BASIC_INFO_SUCCESS) {
                let clientData = this.state.clientData;
                let formErrors = this.state.formErrors;
                formErrors.companyName = '';
                clientData.companyInfo['companyName'] = clientBasicInfoData[0].company_name;
                clientData.companyInfo['companyEmail'] = clientBasicInfoData[0].company_email;
                clientData.companyInfo['companyContactNum'] = clientBasicInfoData[0].phone_number;
                clientData.companyInfo['websiteUrl'] = clientBasicInfoData[0].web_site;
                clientData.companyInfo['companyRegNum'] = clientBasicInfoData[0].company_no;
                clientData.companyInfo['vatNum'] = clientBasicInfoData[0].vat_number;

                if (clientBasicInfoData[0].location) {
                    clientData.companyInfo['location'] = clientBasicInfoData[0].location.location;
                    clientData.companyInfo['locationId'] = clientBasicInfoData[0].location.id;
                    clientData.companyInfo['googleLocation'] = clientBasicInfoData[0].location.lat_long ? clientBasicInfoData[0].location.lat_long : '';
                    clientData.companyInfo['venue'] = clientBasicInfoData[0].location.venue ? clientBasicInfoData[0].location.venue : '';
                    clientData.companyInfo['streetOne'] = clientBasicInfoData[0].location.street1 ? clientBasicInfoData[0].location.street1 : '';
                    clientData.companyInfo['streetTwo'] = clientBasicInfoData[0].location.street2 ? clientBasicInfoData[0].location.street2 : '';
                    clientData.companyInfo['city'] = clientBasicInfoData[0].location.city ? clientBasicInfoData[0].location.city : '';
                    clientData.companyInfo['state'] = clientBasicInfoData[0].location.state ? clientBasicInfoData[0].location.state : '';
                    clientData.companyInfo['country'] = clientBasicInfoData[0].location.country ? clientBasicInfoData[0].location.country : '';
                    clientData.companyInfo['postcode'] = clientBasicInfoData[0].location.postcode ? clientBasicInfoData[0].location.postcode : '';
                    formErrors.location = '';
                    formErrors.city = '';
                    formErrors.state = '';
                    formErrors.country = '';
                    formErrors.postcode = '';
                    formErrors.locationBilling = '';
                    formErrors.cityBilling = '';
                    formErrors.stateBilling = '';
                    formErrors.countryBilling = '';
                    formErrors.postcodeBilling = '';
                    
                } else {
                    clientData.companyInfo['location'] = '';
                    clientData.companyInfo['locationId'] = '';
                    clientData.companyInfo['googleLocation'] = '';
                    clientData.companyInfo['venue'] = '';
                    clientData.companyInfo['streetOne'] = '';
                    clientData.companyInfo['streetTwo'] = '';
                    clientData.companyInfo['city'] = null;
                    clientData.companyInfo['state'] = null;
                    clientData.companyInfo['country'] = null;
                    clientData.companyInfo['postcode'] = null;

                    formErrors.location = MSG_REQUIRED;
                    formErrors.city = MSG_REQUIRED;
                    formErrors.state = MSG_REQUIRED;
                    formErrors.country = MSG_REQUIRED;
                    formErrors.postcode = MSG_REQUIRED;

                    formErrors.locationBilling = MSG_REQUIRED;
                    formErrors.cityBilling = MSG_REQUIRED;
                    formErrors.stateBilling = MSG_REQUIRED;
                    formErrors.countryBilling = MSG_REQUIRED;
                    formErrors.postcodeBilling = MSG_REQUIRED;
                    
                }

                clientData.companyInfo['additionalText'] = clientBasicInfoData[0].note ? clientBasicInfoData[0].note : '';
                clientData.companyInfo['logo'] = clientBasicInfoData[0].logo ? clientBasicInfoData[0].logo : '';

                clientData.companyInfo['signature'] = clientBasicInfoData[0].signature ? clientBasicInfoData[0].signature : '';

                clientData.companyInfo['noLocationFound'] = false;
                clientData.companyInfo['category'] = null;

                formErrors.timeZone = MSG_REQUIRED;
                clientData.companyInfo['timeZone'] = null;
                if (clientBasicInfoData[0].region_time_zone && clientBasicInfoData[0].region_time_zone.id) {
                    clientData.companyInfo['timeZone'] = clientBasicInfoData[0].region_time_zone.id;
                    formErrors.timeZone = '';
                }

                this.setState({ clientData: clientData, imgUrl: clientBasicInfoData[0].logo, formErrors: formErrors });

            }
        }

        // CHECKING DYNAMIC FIELDS DATA LISTING 
        if (dynFieldsActivity && (dynFieldsStatus !== prevProps.dynFieldsStatus || dynFieldsActivity !== prevProps.dynFieldsActivity)) {
            var arrResp = dynFieldsActivity.split('~~');
            var actString = arrResp[0];

            // types.DYNAMIC_FIELDS_LIST_SUCCESS, types.DYNAMIC_FIELDS_LIST_ERROR
            if (actString === types.DYNAMIC_FIELDS_LIST_SUCCESS) {
                if (this.props.hasOwnProperty('dynFieldsAllItems')) {
                    if (this.props.dynFieldsAllItems.length === 0) {
                        this.setState({ dynFieldsAllItems: [] });
                    }
                    else {
                        let tmpObj = {};
                        let fieldsObj = {};
                        let allPagesObj = [];
                        this.props.dynFieldsAllItems.forEach((rObj) => {
                            if (!Array.isArray(rObj.field_details)) rObj.field_details = []; // IF OBJECT {} RETURNED, CONVERT TO ARRAY 
                            if (rObj.show_tab && rObj.field_details.length > 0) {
                                fieldsObj = rObj.field_details;
                                let iconName = '';
                                if (!rObj.icon_name || rObj.icon_name === null || rObj.icon_name.trim().length === 0) {
                                    let filterObj = { pageName: '', iconName: '' };
                                    filterObj = DYNAMIC_PAGE_ICONS.filter(pageDet => pageDet.pageName.trim().toLowerCase() === rObj.name.trim().toLowerCase()); // DEFINED IN staticConfigs.js
                                    if (filterObj.length) iconName = filterObj[0].iconName;
                                }
                                else {
                                    iconName = rObj.icon_name;
                                }

                                tmpObj = {
                                    id: rObj.id, name: rObj.name, field_details: fieldsObj, show_tab: rObj.show_tab, icon_name: iconName, user_type: rObj.user_type
                                };

                                allPagesObj.push(tmpObj);
                            }

                        });
                        this.setState({ dynFieldsAllItems: allPagesObj }, () => {
                        });
                    }
                }
                else {
                    this.setState({ dynFieldsAllItems: [] });
                }
            }
            else if (actString === types.DYNAMIC_FIELDS_LIST_ERROR) {
                this.setState({ toastSuccess: false, toastFlag: true, toastMessage: MSG_ERROR });
                setTimeout(() => {
                    this.onCloseToast();
                }, 3000);
            }
            else if (actString === types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS) {
                this.callValidate();
                this.setState({ toastSuccess: true, toastFlag: true, toastMessage: MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS });
                setTimeout(() => {
                    this.onCloseToast();
                }, 3000);
            }
            else if (actString === types.DYNAMIC_FIELDS_DATA_SAVE_ERROR) {
                this.setState({ toastSuccess: false, toastFlag: true, toastMessage: MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR });
                setTimeout(() => {
                    this.onCloseToast();
                }, 4000);
            }
        }

        if ((timezonesListStatus !== prevProps.timezonesListStatus || timezonesListActivity !== prevProps.timezonesListActivity)) {
            let arrResp = (timezonesListActivity) ? timezonesListActivity.split('~~') : [];
            let actString = arrResp[0];
            if (actString === types.TIMEZONES_LIST_SUCCESS) {
                if (timezonesListStatus === 200) {
                    // let tz = this.props.timeZonesAllItems;
                    // let newTZ = tz.filter(item => item.region.trim().toLowerCase()===DEFAULT_TIME_ZONE.trim().toLowerCase()); 
                    // let defTZId = 0 ;
                    // if(newTZ.length) defTZId = newTZ[0].id;
                    // let clientData = this.state.clientData; 
                    // if(!clientData.companyInfo.timeZone) clientData.companyInfo.timeZone = defTZId;
                    // this.setState({clientData:clientData,defaultTimeZoneId:defTZId,timeZonesList:this.props.timeZonesAllItems}) 
                    this.setState({ timeZonesList: this.props.timeZonesAllItems })
                }
                else {
                    // timezonesListErrorData
                    this.setState({ toastSuccess: false, toastFlag: true, toastMessage: MSG_TIMEZONE_DATA_ERROR });
                    setTimeout(() => { this.onCloseToast(); }, 5000);
                }
            }
            else if (actString === types.TIMEZONES_LIST_ERROR) {
                // timezonesListErrorData
                this.setState({ toastSuccess: false, toastFlag: true, toastMessage: MSG_TIMEZONE_DATA_ERROR });
                setTimeout(() => { this.onCloseToast(); }, 5000);
            }
        }
    }

    changeCategorySaveSuccess = (flag) => {
        this.setState({ categorySaveSuccess: flag });
    }

    redirectToEvents = (eventId) => {
        if(eventId && parseInt(eventId,10)) {
            this.props.redirectToEventsFromClientList(eventId);
        }
    }

    componentDidMount() {

        if (this.state.timeZonesList.length === 0) {
            this.props.timeZonesListAction();
        }

        // if(this.state.clientId!==undefined){
        //     const clientId = this.state.clientId; 
        //     this.props.clientEditAction(clientId); 
        //     this.props.validateClientDetailsAction(clientId); // TO VALIDATE MANDATORY DATA ADDED WHITE EDIT CLIENT DETAILS 
        // }
        // else {
        //     // this.props.validateClientAddAction(); // TO VALIDATE MANDATORY DATA ADDED BEFORE CREATING CLIENT
        // }


        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
        }

        if (userGroup === LOGIN_AFFILIATE_GROUP) {
            if (this.state.clientId !== undefined) document.title = LBL_APP_NAME + " - " + LBL_EDIT_CLIENT;
            else document.title = LBL_APP_NAME + " - " + LBL_ADD_CLIENT;

            document.body.classList.add('body-affiliate');
            this.props.clientCategoryList();
            // this.props.aflt_departmentsListAction({associated:'1'});
            this.props.aflt_departmentsListAction();
        } else if (userGroup === LOGIN_CLIENT_GROUP) {
            document.title = LBL_APP_NAME + " - " + LBL_COMPANY_PROFILE;
            document.body.classList.add('body-client');
        } else {
            document.body.classList.add('body-super');
        }

        // let grpProfileId = userGroupData.profile_id;
        // let listDynData = {groupId: LOGIN_CLIENT_GROUP, reqFrom:userGroup, profileId:grpProfileId}; 
        // this.setState({listDynData:listDynData}, () => { 
        //     this.props.dynamicFieldsListAction(listDynData);
        // });  

    }

    render() {

        const { status, locationsList, prmryUsers } = this.props; // sectors,subSectors,
        const { toastMessage, toastFlag, toastSuccess, clientId } = this.state;

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
        }

        if (status === 401 || status === 403) {
            if (userGroup === LOGIN_AFFILIATE_GROUP) {
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            } else {
                return <Redirect to={ROUTE_REFRESH} />;
            }
        }

        let companyName = LBL_ADD_CLIENT;
        if (this.state.clientData.companyInfo.companyName) companyName = this.state.clientData.companyInfo.companyName;
        //let primeEmail = this.state.clientData.primaryContact.emailAddress; 

        let validationMsgStr = '';
        if (this.state.validationMsgArr.length) {
            if (!clientId) { // CLIENT ADD VALIDATION   
                this.state.validationMsgArr.forEach(item => {
                    if (validationMsgClientAdd[item]) {
                        validationMsgStr += validationMsgClientAdd[item] ? validationMsgClientAdd[item] + '' : '';
                    }
                    else {
                        console.log(item + ' not listed in validationMsgClientAdd');
                    }
                });
                // EXCEPTION HANDLING 
                // if(validationMsgStr==='') validationMsgStr = validationMsgClientAdd['common_error'];
            }
            else {
                this.state.validationMsgArr.forEach(item => {
                    if (item.documents) {
                        validationMsgStr += validationMsgClientDetails['documents_START'] + item.documents.join(', ') + validationMsgClientDetails['documents_END'];
                    }
                    else {
                        if (validationMsgClientDetails[item]) {
                            validationMsgStr += validationMsgClientDetails[item] ? validationMsgClientDetails[item] + '' : '';
                        }
                        else {
                            console.log(item + ' not listed in validationMsgClientDetails');
                        }
                    }
                });

                // EXCEPTION HANDLING 
                // if(validationMsgStr==='') validationMsgStr = validationMsgClientDetails['common_error'];
                // else validationMsgStr = validationMsgClientDetails['common_header']+validationMsgStr;  
            }

        }

        let pcEmail = this.state.primaryContactEmailAddress ? this.state.primaryContactEmailAddress : '';
        let default_event_key = 'company-info-tab';
        if (this.props.fromExpiryCertificatesWindow) {
            default_event_key = 'documents-tab';
            this.props.fromExpiryCertificates(false);
        }

        return (
            <React.Fragment>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="detail-head border-bottom pb-2 padding-top-7">
                    <h6>{companyName}
                        <button className="close-filter text-muted" onClick={this.onHideFilterBy}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </h6>
                </div>

                <div className="row">
                    {validationMsgStr.length > 0 && <div className="text-validation"><small>{ReactHtmlParser(validationMsgStr)}</small></div>}
                </div>
                <Scrollbars style={{ height: '100vh' }} autoHide renderThumbVertical={this.renderThumb} >
                    <div className="filter-content">
                        <Tab.Container id="quote-details-tab" activeKey={this.state.clientData.activeTab}>
                            <Nav variant="pills">
                                {/*<i className="la la-cube"></i> <i className="las la-user-astronaut"></i> <i className="las la-map-marker-alt"></i> <i className="las la-money-check-alt"></i> <i className="las la-file-alt"></i> <i className={item.icon_name}></i> */}

                                <Nav.Item className="profile-tab-pills" >
                                    <Nav.Link eventKey={"company-info-tab"} onClick={(e) => this.onTabChange(e, "company-info-tab")}  ><small> {LBL_BASIC_INFO}</small></Nav.Link>
                                </Nav.Item>

                                {Number(clientId) > 0 &&
                                    <Nav.Item>
                                        <Nav.Link className={clientId === undefined ? 'disabled' : ''} onClick={(e) => this.onTabChange(e, "company-primary-contact-tab")} eventKey="company-primary-contact-tab"><small>{LBL_PRIMARY_CONTACT}</small></Nav.Link>
                                    </Nav.Item>
                                }

                                {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 &&
                                    <Nav.Item>
                                        <Nav.Link className={clientId === undefined ? 'disabled' : ''} onClick={(e) => this.onTabChange(e, "contact-details-tab")} eventKey="contact-details-tab"><small>{LBL_CONTACT_DETAILS}</small></Nav.Link>
                                    </Nav.Item>
                                }

                                {(userGroup === LOGIN_AFFILIATE_GROUP) && Number(clientId) > 0 && pcEmail && pcEmail.length > 1 &&
                                    <Nav.Item>
                                        <Nav.Link className={clientId === undefined ? 'disabled' : ''} onClick={(e) => this.onTabChange(e, 'rate-card-tab')} eventKey="rate-card-tab"><small>{LBL_RATE_CARD}</small></Nav.Link>
                                    </Nav.Item>
                                }

                                {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 &&
                                    <Nav.Item>
                                        <Nav.Link className={clientId === undefined ? 'disabled' : ''} onClick={(e) => this.onTabChange(e, 'documents-tab')} eventKey="documents-tab"><small>{LBL_DOCUMENTS}</small>
                                        </Nav.Link>
                                    </Nav.Item>
                                }

                                {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 && this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item, index) => {
                                    return (<Nav.Item key={"company-Dynamic-ItemTab_" + index}>
                                        <Nav.Link className={(clientId === undefined ? ' disabled' : '')} onClick={(e) => this.onTabChange(e, "company-Dynamic-tab_" + index)} eventKey={"company-Dynamic-tab_" + index}  ><small>{item.name}</small></Nav.Link>
                                    </Nav.Item>
                                    )
                                })}

                                {Number(clientId) > 0 && pcEmail && pcEmail.length > 1 &&
                                    <Nav.Item>
                                        <Nav.Link className={clientId === undefined ? 'disabled' : ''} onClick={(e) => this.onTabChange(e, 'events-tab')} eventKey="events-tab"><small>{LBL_ALL_EVENTS}</small>
                                        </Nav.Link>
                                    </Nav.Item>
                                }


                            </Nav>

                            <Tab.Content>

                                <Tab.Pane eventKey="company-info-tab">
                                    <CompanyInfo
                                        {...this.state}
                                        changeCategorySaveSuccess={this.changeCategorySaveSuccess}
                                        categorySaveSuccess={this.state.categorySaveSuccess}
                                        clientCategoryValidationMsg={this.state.clientCategoryValidationMsg}
                                        onClientInputChange={this.onClientInputChange}
                                        onClearClient={this.onClearClient}
                                        filteredClient={this.state.filteredClient}
                                        addNewButtonClicked={this.state.addNewButtonClicked}
                                        onClientSearch={this.onClientSearch}
                                        onSelectClientList={this.onSelectClientList}
                                        clientFullListData={this.state.clientFullListData}
                                        clientCategoryBasicData={this.state.clientCategoryBasicData}
                                        showNameInHeader={companyName} locations={locationsList}
                                        onsearchLocation={this.onSearchLocation}
                                        onPhoneInputChange={this.onPhoneInputChange}
                                        onSelectLocation={(e, id) => this.onSelectLocation(e, id)}
                                        saveFormData={(e) => this.saveFormData(e, 'company-info-tab')}
                                        onHandleChange={(e) => this.onHandleChange(e, 'company-info-tab')}
                                        deactivateUser={(e) => this.deactivateUser()}
                                        activateUser={(e) => this.activateUser()}
                                        onGetGoogleLoc={(e, id) => this.onGetGoogleLoc(e, id)}
                                        googleLocSelect={(e, id) => this.googleLocSelect(e, id)}
                                        is_active={this.state.is_active}
                                        clientActivatedSuccess={this.state.clientActivatedSuccess}
                                        clientDeactivatedSuccess={this.state.clientDeactivatedSuccess}
                                        deptMultiSelList={this.state.deptMultiSelList}
                                        handleChangeMultiSel={this.handleChangeMultiSel}
                                    />
                                </Tab.Pane>

                                <Tab.Pane eventKey="company-primary-contact-tab">
                                    <PrimaryContact showNameInHeader={companyName} users={prmryUsers} saveFormData={(e) => this.saveFormData(e, 'company-primary-contact-tab')} onContactInputChange={this.onContactInputChange} onHandleChange={(e) => this.onHandleChange(e, 'company-primary-contact-tab')} onSelectPrmyUser={(e) => this.onSelectPrmyUser(e)} resendEmail={(e) => this.resendEmail(e)} {...this.state} />
                                </Tab.Pane>

                                <Tab.Pane eventKey="contact-details-tab">
                                    {(clientId !== undefined) &&
                                        <ContactDetails showNameInHeader={companyName} setToasterState={this.setToasterState} resendEmail={(e) => this.resendEmail(e)} {...this.state} reloadContactList={this.state.reloadContactList}
                                        />
                                    }
                                </Tab.Pane>

                                {(userGroup == LOGIN_AFFILIATE_GROUP) && <Tab.Pane eventKey="rate-card-tab">
                                    {/* <RateCard  showNameInHeader={companyName} clientCategoryBasicData={this.props.clientCategoryBasicData} clientId={this.state.clientId} {...this.state} /> */}

                                    <DepartmentRateCard showNameInHeader={companyName} clientCategoryBasicData={this.props.clientCategoryBasicData} clientId={this.state.clientId} {...this.state} clientDepartmentsList={this.state.clientDepartmentsList} />
                                    {/* {this.state.clientData.companyInfo.departments} */}
                                </Tab.Pane>}

                                <Tab.Pane eventKey="documents-tab">
                                    {(clientId !== undefined) &&
                                        <Documents {...this.state} showNameInHeader={companyName} callparentValidate='yes' callValidate={this.callValidate} document="1" client_id={clientId} noHeaderName="yes"
                                            calledFrom={this.props.calledFrom ? this.props.calledFrom : ''}
                                            callCertificateListAction={this.callCertificateListAction} />
                                        // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020  
                                    }
                                </Tab.Pane>

                                {this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item, index) => {
                                    return (<Tab.Pane eventKey={"company-Dynamic-tab_" + index} key={index} >
                                        <DynamicFieldsDetails showNameInHeader={companyName} dynamicFieldsDataSaveAction={(e) => this.props.dynamicFieldsDataSaveAction(e)} {...this.state} headerText={item.name} dynFieldsActiveItem={item} dynamicFieldsFor={LOGIN_CLIENT_GROUP} noHeaderName="yes" />
                                    </Tab.Pane>
                                    );
                                })}

                                <Tab.Pane eventKey="events-tab"> 
                                    {(clientId !== undefined) &&
                                        <ClientEvents showNameInHeader={companyName} setToasterState={this.setToasterState} {...this.state} client_id={clientId} clientEventsTabClicked={this.state.clientEventsTabClicked} redirectToEvents={this.redirectToEvents}
                                        />
                                    }
                                </Tab.Pane>

                            </Tab.Content>

                        </Tab.Container>

                    </div>
                </Scrollbars>

                <ModalWindow ref={this.modalConfirm} header={LBL_CONFIRM_DATA_CHANGE} type="save" saveFormData={this.saveData} resetModalForm={this.onModalFormReset} needOnCancel={true} onModalCancelClick={this.onModalCancelClick} > {MSG_CONFIRM_DATA_CHANGE_CLIENT}  </ModalWindow>

                <ModalWindow ref={this.logoModalCropper} type="imageCropper" saveFormData={(e) => this.cropImage(e, 'clientLogo')}>
                    <Cropper
                        image={this.state.logoImgUrl}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                    />
                </ModalWindow>
                <ModalWindow ref={this.signModalCropper} type="imageCropper" saveFormData={(e) => this.cropImage(e, 'clientSign')}>
                    <Cropper
                        image={this.state.signImgUrl}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                    />
                </ModalWindow>
            </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
    
    return {
        activeStatus: state.clients.activeStatus,
        client: state.clients.item,
        clientCategoryData: state.clients.clientCategoryListData,
        status: state.clients.status,
        activity: state.clients.activity,
        locationsList: state.clients.locations,
        prmryUsers: state.clients.prmryUsers,
        errorData: state.clients.errorData,
        dynFieldsStatus: state.dynamicFields.dynFieldsStatus,
        dynFieldsActivity: state.dynamicFields.dynFieldsActivity,
        dynFieldsAllItems: state.dynamicFields.dynFieldAllItems,
        newClientId: state.clients.newClientId,
        timeZonesAllItems: state.timeZones.timezonesList,
        timezonesListStatus: state.timeZones.timezonesListStatus,
        timezonesListActivity: state.timeZones.timezonesListActivity,
        timezonesListErrorData: state.timeZones.timezonesListErrorData,
        clientProfileTabActive: state.certificates.clientProfileTabActive,

        validateResponse: state.validate.validateResponse,
        validateStatus: state.validate.validateStatus,
        validateActivity: state.validate.validateActivity,
        validateErrorData: state.validate.validateErrorData,
        fromExpiryCertificatesWindow: state.commons.fromExpiryCertificatesWindow,

        clientProfStatus: state.clients.clientProfStatus,
        clientProfActivity: state.clients.clientProfActivity,
        clientFullData: state.clients.clientFullData,
        clientFullListActivity: state.clients.clientFullListActivity,
        clientBasicInfoData: state.clients.clientBasicInfoData,
        clientBasicInfoActivity: state.clients.clientBasicInfoActivity,

        afltDepartmentsForCrew: state.crews.afltDepartmentsForCrew,
        crewProfileActivity: state.crews.crewProfileActivity,

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        masterLocationListAction: data => masterLocationListAction(data),
        primaryUsersListAction: primaryUsersListAction,
        aflt_departmentsListAction: aflt_departmentsListAction,
        clientEditAction: id => clientEditAction(id),
        clientCompanyInfoAddAction: data => clientCompanyInfoAddAction(data),
        clientCompanyInfoUpdateAction: data => clientCompanyInfoUpdateAction(data),
        clientPrmryCntAddAction: data => clientPrmryCntAddAction(data),
        clientPrmryCntUpdateAction: data => clientPrmryCntUpdateAction(data),
        clientActiveDeactiveAction: id => clientActiveDeactiveAction(id),
        clearAction: clearAction,
        resendEmailAction: resendEmailAction,
        dynamicFieldsListAction: dynamicFieldsListAction,
        dynamicFieldsDataSaveAction: dynamicFieldsDataSaveAction,
        clientContactListAction: clientContactListAction,
        timeZonesListAction: timeZonesListAction,
        clientProfileDeactiveTabAction: clientProfileDeactiveTabAction,
        validateClientAddAction: validateClientAddAction,
        validateClientDetailsAction: validateClientDetailsAction,
        fromExpiryCertificates: fromExpiryCertificates,
        clientCategoryList: clientCategoryList,
        clientFullList: clientFullList,
        getCompanyBasicInfo: getCompanyBasicInfo,
        clientProfileRateCardListAction: clientProfileRateCardListAction,
        clientGetCrewChiefBonusAction: clientGetCrewChiefBonusAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientProfileComponent);
